/**
 * Basecamp Integration Export
 * This is what Agent 1 will import into the integration registry
 */

import type { LucideIcon } from 'lucide-react';
import { BasecampIcon } from '@/components/icons/basecamp-icon';
import { BasecampSidebar } from './basecamp-sidebar';
import { BasecampDashboard } from './basecamp-dashboard';
import type { Integration } from '@/types/integration';
import { basecampEntityMenus } from './basecamp-entity-menus';

export const basecampIntegration: Integration = {
  id: 'basecamp',
  name: 'Basecamp',
  shortName: 'BC',
  icon: BasecampIcon as LucideIcon,
  enabled: true, // Will be controlled by settings
  configured: true, // Will check for API credentials
  SidebarView: BasecampSidebar,
  MainView: BasecampDashboard,
  color: 'green',
  description: 'Project management and collaboration',
  entityContextMenus: basecampEntityMenus,
  addToChatForTabWithoutPath: true,
};

// Export individual components for testing
export { BasecampSidebar } from './basecamp-sidebar';
export { BasecampDashboard } from './basecamp-dashboard';
export { ProjectCard } from './components/project-card';
export { TodoItem } from './components/todo-item';
export { SyncStatus } from './components/sync-status';

// Export Basecamp-specific types
export type { 
  BasecampProject, 
  BasecampTodo, 
  BasecampComment, 
  BasecampActivity,
  BasecampAssignment,
  BasecampAuthStatus,
  NavigationState,
  ProjectMetrics
} from '@/types/basecamp';
